import type { IUserRepository } from '../../domain/repositories/UserRepository';
import type { IUserDomainService } from '../../domain/services/UserDomainService';
import type { CreateUserRequest, User } from '../../domain/entities/User';
import type { Result } from '../../shared/types/common.types';

export interface ICreateUserUseCase {
  execute(userData: CreateUserRequest): Promise<Result<User>>;
}

export class CreateUserUseCase implements ICreateUserUseCase {
  private readonly userRepository: IUserRepository;
  private readonly userDomainService: IUserDomainService;

  constructor(
    userRepository: IUserRepository,
    userDomainService: IUserDomainService
  ) {
    this.userRepository = userRepository;
    this.userDomainService = userDomainService;
  }

  async execute(userData: CreateUserRequest): Promise<Result<User>> {
    const validation = this.userDomainService.validateUserData(userData);
    if (!validation.success) {
      return validation;
    }

    const existingUserResult = await this.userRepository.findByEmail(userData.email);
    if (existingUserResult.success && existingUserResult.data) {
      return { success: false, error: new Error('User with this email already exists') };
    }

    return await this.userRepository.create(userData);
  }
}
